'use client'

// noinspection ES6UnusedImports
import type {} from '@mui/lab/themeAugmentation'
// noinspection ES6UnusedImports
import type {} from '@mui/x-data-grid/themeAugmentation'
// noinspection ES6UnusedImports
import type {} from '@mui/x-date-pickers/themeAugmentation'
// noinspection ES6UnusedImports
import type {} from '@mui/material/themeCssVarsAugmentation'
// import type {} from '@mui/x-tree-view/themeAugmentation'
import type { Theme } from '@mui/material/styles'
import { ThemeProvider as ThemeVarsProvider } from '@mui/material/styles'
import { useSettingsContext } from '../settings'
import { createTheme } from './create-theme'
import { Rtl } from './with-settings/right-to-left'
import { useTranslate } from '@repo/shared-locales/locales/use-locales'
// eslint-disable-next-line no-restricted-imports
import type { ThemeProviderProps as MuiThemeProviderProps } from '@mui/material/styles/ThemeProvider'
import type { ThemeOptions } from './types'
// noinspection ES6UnusedImports
import type {} from './extend-theme-types'
import CssBaseline from '@mui/material/CssBaseline'

// --------------------------------------------------------------------------------------------- //

type ThemeProviderProps = Omit<MuiThemeProviderProps, 'theme'> & {
  theme?: Theme
  themeOverrides?: ThemeOptions
}

export function ThemeProvider({ themeOverrides, children, ...other }: ThemeProviderProps) {
  const { currentLang } = useTranslate()

  const settings = useSettingsContext()

  const theme = createTheme({
    settingsState: settings.state,
    localeComponents: currentLang?.systemValue,
    themeOverrides
  })

  return (
    <ThemeVarsProvider disableTransitionOnChange theme={theme} {...other}>
      <CssBaseline />
      <Rtl direction={settings.state.direction!}>{children}</Rtl>
    </ThemeVarsProvider>
  )
}
